import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useTournament } from '@/hooks/use-tournament';
import { Badge } from '@/components/ui/badge';

interface RoundHistoryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const RoundHistoryDialog: React.FC<RoundHistoryDialogProps> = ({ open, onOpenChange }) => {
  const { tournamentState } = useTournament();
  const isAmericano = tournamentState.tournamentType === 'americano' || tournamentState.tournamentType === 'team_americano';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Round History</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {isAmericano ? (
            tournamentState.roundAmericanoMatches.map((round, idx) => (
              <div key={idx} className="border rounded-md p-3">
                <div className="flex items-center justify-between mb-2">
                  <div className="font-semibold">Round {idx + 1}</div>
                  <Badge variant="outline">{round.results?.length || 0} results</Badge>
                </div>
                <div className="space-y-2">
                  {(round.results || round.matches).map((m: any, i: number) => (
                    <div key={i} className="text-sm">
                      <span className="text-muted-foreground">Court {m.court}:</span>{' '}
                      <span>{m.team1?.player1?.name || m.players?.team1?.player1} & {m.team1?.player2?.name || m.players?.team1?.player2}</span>
                      <span className="mx-1">vs</span>
                      <span>{m.team2?.player1?.name || m.players?.team2?.player1} & {m.team2?.player2?.name || m.players?.team2?.player2}</span>
                      {m.score && (
                        <span className="ml-2 font-medium">({m.score.team1} - {m.score.team2})</span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            tournamentState.roundCourts.map((round, idx) => (
              <div key={idx} className="border rounded-md p-3">
                <div className="flex items-center justify-between mb-2">
                  <div className="font-semibold">Round {idx + 1}</div>
                  <Badge variant="outline">{(round.results || []).length} results</Badge>
                </div>
                <div className="space-y-2">
                  {round.courts.map((court, i) => (
                    <div key={i} className="text-sm">
                      <span className="text-muted-foreground">Court {i + 1}:</span>{' '}
                      <span>{court[0]?.name} & {court[1]?.name}</span>
                      <span className="mx-1">vs</span>
                      <span>{court[2]?.name} & {court[3]?.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

